$(document).ready(function() {
  function showFilters() {
    $('.ph-navbarSmall').removeClass('ph-d-none');
    $.colorbox({
      inline: true,
      href: '.ph-navbarSmall',
      scrolling: true,
      maxHeight: 300,
      maxWidth: 350,
      overlayClose: false,
      onClosed: function() {
        $('.ph-navbarSmall').addClass('ph-d-none');
      }
    });
  }

  $(document).on('click', '.ph-showFilters', function() {
    showFilters();
  });
});
